import { apiClient } from './client';

export interface QuoteLineItem {
  description: string;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
  category?: string;
}

export interface QuoteAnalysisResult {
  vendorName: string | null;
  vendorPhone: string | null;
  vendorEmail: string | null;
  lineItems: QuoteLineItem[];
  totalAmount: number | null;
  paymentTerms: string | null;
  dueDate: string | null;
  confidence: number;
  rawText: string | null;
}

export interface AnalyzeQuoteRequest {
  eventId: string;
  s3Key: string;
  fileName: string;
  mimeType: string;
  fileSizeBytes: number;
}

export interface AnalyzeQuoteResponse {
  documentId: string;
  analysis: QuoteAnalysisResult;
}

export interface QuoteImportItem {
  description: string;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
  accepted: boolean;
  vendorCategoryId?: string;
  statusId?: string;
  category?: string;
}

export interface QuoteImportConfirmRequest {
  eventId: string;
  documentId: string;
  vendorId?: string;
  vendorName?: string;
  items: QuoteImportItem[];
}

export async function analyzeQuote(data: AnalyzeQuoteRequest): Promise<AnalyzeQuoteResponse> {
  const { data: result } = await apiClient.post<AnalyzeQuoteResponse>(
    '/quote-import/analyze',
    data,
  );
  return result;
}

export async function confirmQuoteImport(data: QuoteImportConfirmRequest): Promise<unknown[]> {
  const { data: result } = await apiClient.post<unknown[]>('/quote-import/confirm', data);
  return result;
}
